module.exports = __webpack_public_path__ + "static/media/16UNODC40.98cf7cf0.jpg";